




import { Component, Vue } from 'vue-property-decorator'

import { ApolloOperationVariables } from '~base/common/types'

@Component<UserStoriesPage>({
  layout: 'empty',
  apollo: {
    author: {
      query: require('~base/graphql/queries/FetchAuthorIdBySlug.gql'),
      variables(): ApolloOperationVariables {
        const slug = this.$route.params.slug
        return {
          author_slug: slug,
        }
      },
      prefetch({ route }: any): ApolloOperationVariables {
        const slug = route.params.slug
        return {
          author_slug: slug,
        }
      },
      result({ data }) {
        if (data && data.user) {
          this.$router.push({
            name: 'author-slug-id',
            params: {
              slug: data.user.slug || '',
              id: `${data.user.databaseId}` || '',
            },
          })
        }
      },
    },
  },
})
export default class UserStoriesPage extends Vue {}
